import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { getEventQueue } from 'shared/utils/eventQueue';

export function useMicrofrontEvents(
  manifest: IMicrofrontendManifest | undefined,
  loadingSetter: (loading: boolean) => void,
) {
  const eventQueue = getEventQueue();

  const handleInitialLoadingStart = React.useCallback(() => loadingSetter(true), [loadingSetter]);
  const handleInitialLoadingEnd = React.useCallback(() => loadingSetter(false), [loadingSetter]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
      handleInitialLoadingStart,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
        handleInitialLoadingStart,
      );
  }, [eventQueue, handleInitialLoadingStart, manifest]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
      handleInitialLoadingEnd,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
        handleInitialLoadingEnd,
      );
  }, [eventQueue, handleInitialLoadingEnd, manifest]);
}
